import React from "react";
type CtaMicrocopyProps = {
  items: string[];
  tone?: "dark" | "light";
  align?: "center" | "start";
  className?: string;
};
export function CtaMicrocopy({
  items,
  tone = "dark",
  align = "center",
  className = ""
}: CtaMicrocopyProps) {
  return <p className={`mt-4 flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px] font-medium md:text-sm ${align === "center" ? "justify-center" : "justify-center lg:justify-start"} ${tone === "dark" ? "text-ink-soft" : "text-white/75"} ${className}`} data-id="element-78" data-mp="tjhfmihs3wou">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-79" data-mp="1q6drmvqma93v" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className={tone === "dark" ? "text-gold-deep" : "text-gold"} data-id="element-80" data-mp="1cga7qbf7mrhl">
              •
            </span>}
          <span data-id="element-81" data-mp="1hebq0u4tams0">{item}</span>
        </React.Fragment>)}
    </p>;
}